import { useEffect } from 'react';
import { getCLS, getFID, getLCP, getTTFB } from 'web-vitals';
import { useRootStore } from '../../store/contexts';

export const useWebVitals = () => {
  const rootStore = useRootStore();

  useEffect(() => {
    getCLS((metric) => {
      rootStore.systemMonitorStore.updateWebVitals('CLS', metric.value);
    });

    getFID((metric) => {
      rootStore.systemMonitorStore.updateWebVitals('FID', metric.value);
    });

    getLCP((metric) => {
      rootStore.systemMonitorStore.updateWebVitals('LCP', metric.value);
    });

    getTTFB((metric) => {
      rootStore.systemMonitorStore.updateWebVitals('TTFB', metric.value);
    });
  }, [rootStore]);
};
